import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import './ModalInterviewSchedule.css';

export const InterviewDatetime = ({ reschedule, interview_datetime, interview_timezone, isScheduling }) => {
   const getTimezoneCode = () => {
      if (interview_timezone) {
         return interview_timezone.split(' - ')[0];
      }
      return '';
   };

   const formatDateTime = () => {
      const onlyDateString = interview_datetime
         ? new Date(interview_datetime).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
           })
         : '-No date available-';

      const onlyTimeString = interview_datetime
         ? new Date(interview_datetime).toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
           })
         : '-No time available-';

      return `${onlyDateString} at ${onlyTimeString} ${getTimezoneCode()}`;
   };

   // if the status is not "interview_scheduled", do not show anything
   if (!isScheduling) return null;
   // if there is no interview_datetime, show "No date scheduled" and "Schedule" link
   if (!interview_datetime) {
      return (
         <div className="interview-info">
            <span className="interview-datetime" id="datetime-display">
               No date scheduled
            </span>
            <span>•</span>
            <a className="reschedule-link" onClick={reschedule}>
               Schedule
            </a>
         </div>
      );
   }

   return (
      <div className="interview-info">
         <span className="interview-datetime" id="datetime-display">
            {formatDateTime()}
         </span>
         <span>•</span>
         <a className="reschedule-link" onClick={reschedule}>
            Reschedule
         </a>
      </div>
   );
};
